import React, { useContext } from "react";
import listContext from "../list_context";

export const RemoveButton = props => {
  const state = useContext(listContext);
  return (
    <button className="round round--del" onClick={() => state.removePd(state.cart.indexOf(props.pd))}>
      x 
    </button>
  );
};
